import React from "react";
import LinkChooser from './linkChooser'

import s from "./links.module.css"


// Since DOM elements <a> cannot receive activeClassName,
// destructure the prop here and pass it only to GatsbyLink
const Links = (props) => (
  <LinkChooser id={props.id ? props.id : undefined} to={props.to} activeClassName={props.activeClassName} className={`${s.link} ${props.className}`}>{props.children}</LinkChooser>
)

export const SimpleLink = (props) => (
  <a href="#" className={`${s.link} ${props.className}`} onClick={props.onClick}>{props.children}</a>
);

Links.defaultProps = {
  id:false,
  className:'',
  to:'/',
  activeClassName:''
};

export default Links
